<div class="auth-wrapper auth-v2">
	<div class="auth-inner row m-0">
		<a class="brand-logo" href="javascript:void(0);">
			<h2 class="brand-text text-primary ml-1" style="font-family: 'Montserrat', Helvetica, Arial, serif !important">Grupo 2E</h2>
		</a>
		<div [hidden]="enviar" class="d-flex col-lg-12 align-items-center auth-bg px-2 p-lg-5">
			<div class="col-4 col-sm-4 col-md-4 col-lg-4 px-xl-2 mx-auto">
				<h2 class="card-title font-weight-bold mb-1">Redefinir Senha</h2>
				<p [hidden]="enviar" class="card-text mb-2">Insira o email cadastrado para o envio das instruções.</p>
				<p [hidden]="!enviar" [hidden]="alterar" class="card-text mb-2">Insira uma nova senha para a sua conta.
				</p>

				<ngb-alert [type]="'info'" [dismissible]="false" *ngIf="error">
					<div class="alert-body">
						<p>{{ error }}</p>
					</div>
				</ngb-alert>

				<form [hidden]="enviar" class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
					<div class="form-group">
						<label class="form-label" for="login-email">Email</label>
						<input type="text" formControlName="email" class="form-control"
							[ngClass]="{ 'is-invalid': submitted && f.email.errors }" placeholder="email@dominio.com"
							aria-describedby="login-email" autofocus="" tabindex="1" />
						<div *ngIf="submitted && f.email.errors" class="invalid-feedback">
							<div *ngIf="f.email.errors.required">Email is required</div>
							<div *ngIf="f.email.errors.email">Email must be a valid email address</div>
						</div>
					</div>
					<button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
						<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Enviar
					</button>
				</form>
				<br>

				<form [hidden]="!enviar" [hidden]="alterar" class="auth-login-form mt-2"
					[formGroup]="changePasswordForm" (ngSubmit)="alterarSenha()">

					<div class="form-group">
						<label class="form-label form-ngModel" for="login-email">Senha</label>
						<input required="" type="password" formControlName="new_password" class="form-control"
							placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
							aria-describedby="login-email" autofocus="" tabindex="1" />
					</div>

					<br>

					<div class="form-group">
						<label class="form-label form-ngModel" for="login-email">Confirmar Senha</label>
						<input required type="password" formControlName="confirm_password" class="form-control"
							placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
							aria-describedby="login-email" autofocus="" tabindex="1" />
					</div>

					<button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" type="submit"
						rippleEffect>
						<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Alterar senha
					</button>

				</form>
				<a [hidden]="buttonLogin" routerlink="/login" href="/login" ng-reflect-router-link="/login"
					class="btn btn-secondary botao-cancelar" rippleEffect>Login</a>
				<br>
			</div>
		</div>
	</div>
</div>